/**
 * A HOC wrapping Material UIs Table Component. Used to unify the styles across
 * all of our tables
 */
import React from 'react';
import { TableBody as MuiTableBody } from '@mui/material';

export default function TableBody(props) {
  return <MuiTableBody padding="normal" {...props} />;
}
